import { Link } from "react-router-dom";

export const TermsCheckbox = ({ checked, onChange, testid }) => (
  <label className="flex items-start gap-2.5 text-xs text-[#9CA3AF] cursor-pointer select-none">
    <input
      type="checkbox"
      data-testid={testid}
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className="mt-0.5 h-4 w-4 accent-[#C9A227] cursor-pointer"
    />
    <span>
      Ho letto e accetto i{" "}
      <Link to="/termini" target="_blank" className="text-[#C9A227] underline underline-offset-2">Termini e Condizioni</Link>{" "}
      (inclusa la politica su resi e buoni negozio) e la{" "}
      <Link to="/privacy" target="_blank" className="text-[#C9A227] underline underline-offset-2">Privacy Policy</Link>.
    </span>
  </label>
);
